var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8376 23.338C4.8594 23.338 0 18.478 0 12.5003C0 6.52269 4.8594 1.66272 10.8376 1.66272C13.5787 1.66272 16.1515 2.65813 18.1556 4.49554C17.4876 4.8916 16.8436 5.32682 16.227 5.79892C14.7013 4.56676 12.7987 3.89611 10.8376 3.89922C6.09991 3.89922 2.2365 7.76263 2.2365 12.5003C2.2365 17.2381 6.09991 21.1009 10.8376 21.1009C17.4295 21.1009 21.3431 14.0546 18.5079 8.57637C19.0657 8.05756 19.6432 7.56045 20.2392 7.08614C21.1879 8.72401 21.6752 10.5816 21.6752 12.4998C21.6752 18.478 16.8158 23.338 10.8376 23.338Z",
    fill: "#049826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1225 18.0714C11.0652 18.0705 11.0095 18.0527 10.9624 18.0201C10.9153 17.9876 10.8789 17.9418 10.8578 17.8886C10.8376 17.8482 9.08897 13.3337 6.38476 11.6255C5.85591 11.3002 5.44933 10.9548 5.61196 10.182C5.77459 9.42992 6.28268 9.00257 7.19793 8.79957C8.82426 8.45354 10.5734 10.9749 11.2234 12.0119C13.5014 8.69806 18.0557 3.49264 24.6845 2.88248C25.004 2.84499 25.1228 3.31905 24.8269 3.45169C24.7254 3.49206 15.25 7.82319 11.4068 17.9088C11.3781 17.9586 11.3366 18 11.2866 18.0286C11.2367 18.0571 11.18 18.0719 11.1225 18.0714Z",
    fill: "#049826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.6c9dda88300566984fa4b8151d80dcec.svg";
export { ForwardRef as ReactComponent };